'use strict';

var FBCsFilterByClassFactory = function FBCsFilterByClassFactory(DataFilter) {
  function FBCsFilterByClass() {
    DataFilter.call(this, 'fares-mode', 'fbcs-grid', 1);
  }
  FBCsFilterByClass.prototype = Object.create(DataFilter.prototype);
  FBCsFilterByClass.prototype.filter = function (data, range) {
    range = range[0];
    var classes = range.classes;
    return DataFilter.prototype.filter(data, classes, 'bookingClass');
  };
  return FBCsFilterByClass;
};
FBCsFilterByClassFactory.$inject = ['DataFilterFactory'];
module.exports = FBCsFilterByClassFactory;